export const safeJSONParse = (data: string) => {
	try {
		return JSON.parse(data);
	} catch (error) {
		return {};
	}
};

/**
 * Parse potentially malformed json input, typecheck, and typecast to type
 */
export const safeJSONParseTo = <T>(
	data: string,
	typeGuard: (sub: unknown) => sub is T,
): T | undefined => {
	try {
		const out = JSON.parse(data);

		return typeGuard(out) ? (out as T) : undefined;
	} catch (error) {
		return undefined;
	}
};
